<template>
  <div class="w-100">
    <img  
      v-if="preview"
      :width="width" 
      :height="height" 
      :src="previewImg" 
      :onerror="url"
    />
    <div v-else class="embed-responsive embed-responsive-16by9 iframe-wrapper post-extra-top-video-youtube">
      <iframe 
        class="embed-responsive-item" 
        :src="url" 
        :allowfullscreen="allowfullscreen"
        :frameborder="frameborder"
        :autoplay="autoplay"
      ></iframe>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from "vue"
import { parseVideoUrl, oembedUrl, parseVideoTag } from "../utils"

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  width: {
    type: String,
    default: "420",
  },
  height: {
    type: String,
    default: "315",
  },
  autoplay: {
    type: String,
    default: "0",
  },
  frameborder: {
    type: String,
    default: "0",
  },
  allowfullscreen: {
    type: Boolean,
    default: false,
  },
  preview: {
    type: Boolean,
    default: false,
  },
  ngShow: {
    type: String,
    default: "showvideo",
  },
})
const previewImg = ref('/static/assets/front-end/img/image-place-holder.png')
const url = computed(() => {
  let src = parseVideoUrl(props.src)

  if (props.preview) {
    const oembedUri = oembedUrl(props.src)
    src = '/static/assets/front-end/img/image-place-holder.png'
    // console.debug("oembedUri: ", oembedUri)
    // console.debug("video_src: ", props.src)
    if (oembedUri) {
      const thumbnailUrl = getThumbnailUrl(oembedUri)
      // console.debug("oembedUri: ", oembedUri, thumbnailUrl)
      thumbnailUrl.then((res) => previewImg.value = res)
      return src
    }
  } else {
    const prefix = src.indexOf('?') == -1 ? '?' : '&'
    // 關閉相關影片推薦
    src += prefix + 'rel=0'
    
    if (props.autoplay == "1") {
      src += '&mute=1&autoplay=1'
    }
    // console.log("autoplay: ", props.autoplay)
    // console.log("src: ", parseVideoUrl(props.src))
  }
  
  return src
})

const getThumbnailUrl = async (url) => {
  return await new Promise((resolve) => {        
    return axios.get(url).then(res => {
      resolve(res.data?.thumbnail_url)
    }).catch(err =>{
      resolve('/static/assets/front-end/img/image-place-holder.png')
    })
  })
}

onMounted(() => {
  $(".iframe-wrapper").each(function () {
    $(this).html(parseVideoTag($(this)[0].innerHTML, props.width, props.height))
  })
})
</script>
<style lang="scss">
.post-extra-top-video-youtube {
  max-height: 60vh;
  // margin-left: -24px;
  // margin-right: -24px;
  .embed-responsive {
    max-height: 60vh;
  }
}
</style>
